function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ScrollLocker = /*#__PURE__*/function () {
  function ScrollLocker(el) {
    _classCallCheck(this, ScrollLocker);
    this.body = document.querySelector('html');
    this.el = el;
    this.y = 0;
  }
  return _createClass(ScrollLocker, [{
    key: "lock",
    value: function lock() {
      this.y = window.pageYOffset;
      this.el.style.height = window.innerHeight + 'px';
      this.el.style.overflow = 'hidden';
      this.el.scrollTop = this.y;
      window.dispatchEvent(new Event('resize'));
    }
  }, {
    key: "unlock",
    value: function unlock() {
      var _this = this;
      this.el.style.height = 'auto';
      this.el.style.overflow = 'visible';

      // scroll the window to the previous position
      setTimeout(function () {
        return window.scrollTo(0, _this.y);
      }, 10);
      window.dispatchEvent(new Event('resize'));
    }
  }]);
}();
export { ScrollLocker as default };